import { DSIcon } from '../../../base';

import styles from './LockRoundedIcon.module.scss';

const BillsLabelCircledIcon = () => (
  <span className={styles['lock-rounded-icon']}>
    <DSIcon name="euro" />
  </span>
);

export default BillsLabelCircledIcon;
